var map = {
	"./maxImages/1504x470.jpg": "c565",
	"./maxImages/枪王射击.jpg": "d7d1",
	"./maxImages/沙漠球球1920x470.jpg": "a1e8",
	"./maxImages/超级坦克王.jpg": "70d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3077";